export default __webpack_public_path__ + "static/media/poppins.d6709983.ttf";